import React from 'react'
import { NavLink } from 'react-router-dom'

const SideNavbar = ({ isAuthenticated }) => {
  const SideNavbar = isAuthenticated ?
    <div className="br-sideleft overflow-y-auto ">
      <label className="sidebar-label pd-x-15 mg-t-20">Navigation</label>
      <nav className="br-sideleft-menu">
        <NavLink exact to="/" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-pie-graph tx-22"></i><span
            className="menu-item-label">หน้าหลัก</span>
          </div>
        </NavLink>
        {/* <NavLink to="/role" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-person tx-22"></i><span className="menu-item-label">Role</span>
          </div>
        </NavLink> */}
        <NavLink to="/project" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-home tx-22"></i><span className="menu-item-label">โครงการ</span>
          </div>
        </NavLink>
        <NavLink to="/defect" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-settings tx-22"></i><span className="menu-item-label">ข้อบกพร่อง</span>
          </div>
        </NavLink>
        <NavLink to="/checklist" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-clipboard tx-22"></i><span
            className="menu-item-label">ตรวจสอบรายการประจำวัน</span>
          </div>
        </NavLink>
        <NavLink to="/mainArea" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-android-radio-button-on tx-22"></i><span
            className="menu-item-label">พื้นที่หลัก</span>
          </div>
        </NavLink>
        <NavLink to="/defectArea" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-arrow-shrink tx-22"></i><span
            className="menu-item-label">บริเวณที่เกิดข้อบกพร่อง</span>
          </div>
        </NavLink>
      </nav>
    </div> : undefined
  return (
    <div>
      {SideNavbar}
    </div>
  )
}

export default SideNavbar




// WEBPACK FOOTER //
// ./src/components/SideNavbar.js